/*
 * @Author: Dom
 * @Date: 2022-07-05 14:42:54
 * @LastEditTime: 2022-07-05 14:46:16
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\upload.ts
 */
import {message} from 'ant-design-vue'
export function beforeUploadTypeSize(info: any){
    const isJpgOrPng = info.type === 'image/jpeg' || info.type === 'image/png'
    const isLt6M = info.size / 1024 / 1024 < 6
    if(!isJpgOrPng){
        message.warning('只能上传图片格式(jpg,png)!')
    }
    if(!isLt6M){
        message.warning('图片大小不能超过6M!')
    }
    return isJpgOrPng&&isLt6M
}
